import React, { useRef, useState } from "react";
import produce from 'immer';
import auth from "../auth";
import Version from "../version";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { useConnect } from 'dotnetify';
import globalState from '../state/GlobalState';
import { useState as useGlobalState } from '@hookstate/core';
import TopContainer from '../controls/TopContainer';
import { Box, BoxTitle, BoxContent, BoxLink } from '../controls/Box';
import ServerState from '../controls/ServerState';
import SparkleDialog from '../controls/components/SparkleDialog';
import { Grid } from "@material-ui/core";
import { LargeButton } from '../controls/components/Buttons';

export default function Support() {
    const { state } = useConnect("Support", {}, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        exceptionHandler: _ => auth.signOut()
    });
    const [localState, internalSetLocalState] = useState({ disabled: false, busy: false, showBuyDataButton: false, dialogOpen: false, ViaplayBuzy: false, CancelViaplayDialogOpen: false, ActivateViaplayDialogOpen: false });
    const setLocalState = (o) => {
        internalSetLocalState(
            produce(draft => {
                draft[Object.keys(o)[0]] = Object.values(o)[0];
            })
        )
    }

    const gstate = useGlobalState(globalState);
    const dialogRef = useRef();

    const openUrl = url => {
        dialogRef.current.openUrl(url);
    };
    const wDim = useWindowDimensions();
    var supportLinks;
    if (gstate.IsNorway.get()) {
        supportLinks = [
            { description: 'Ny kunde?', url: 'https://www.chilimobil.no/sporsmal-hjelp/ny-kunde/', icon: 'question', type: 'border' },
            { description: 'Faktura spørsmål', url: 'https://www.chilimobil.no/sporsmal-hjelp/faktura/', icon: 'question', type: 'background' },
            { description: 'EU/EØS og utlandet', url: 'https://www.chilimobil.no/sporsmal-hjelp/mobilabonnement-norge-utlandet/', icon: 'question', type: 'background' },
            { description: 'Mobilhjelp og mobiloppsett', url: 'https://www.chilimobil.no/sporsmal-hjelp/mobilhjelp-og-oppsett/', icon: 'question', type: 'background' },
            { description: 'Dekning og drift', url: 'https://www.chilimobil.no/sporsmal-hjelp/dekning-og-drift/#generell-dekning', icon: 'question', type: 'background' },
            { description: 'Eierskifte', url: 'https://www.chilimobil.no/sporsmal-hjelp/skjema-og-vilkar/#Eierskifteskjema', icon: 'question', type: 'background' },
            { description: 'Familie - informasjon og hjelp', url: 'https://www.chilimobil.no/sporsmal-hjelp/familie/', icon: 'question', type: 'background' },
            { description: 'BankID på mobil', url: 'https://www.chilimobil.no/sporsmal-hjelp/bankid-mobil/', icon: 'question', type: 'background' },
            { description: 'Annet - Spørsmål og hjelp', url: 'https://www.chilimobil.no/sporsmal-hjelp/', icon: 'question', type: 'background' },
        ]
    } else {
        supportLinks = [
            { description: 'Abonnemang', url: 'https://chilimobil.se/support/abonnemang/', icon: 'question', type: 'background' },
            { description: 'Betalning', url: 'https://chilimobil.se/support/betalning/', icon: 'question', type: 'background' },
            { description: 'I utlandet', url: 'https://chilimobil.se/support/i-utlandet/', icon: 'question', type: 'background' },
            { description: 'Leverans', url: 'https://chilimobil.se/support/leverans/', icon: 'question', type: 'background' },
            { description: 'Surfmängd', url: 'https://chilimobil.se/support/surfmangd/', icon: 'question', type: 'background' },
            { description: 'Teknik - Fix & trix', url: 'https://chilimobil.se/support/teknik-fix-trix/', icon: 'question', type: 'background' },
        ]

    };
    return (
        <React.Fragment>
            <ServerState serverState={state} localState={localState} setLocalState={setLocalState} />
            <SparkleDialog ref={dialogRef} />
            <TopContainer title={gstate.IsSweden.get() ? 'Support' : 'Support' }>
                <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
                    {supportLinks.map((link, index) => {
                        return (
                            <Box key={index} border={link.type === 'border'} background={link.type === 'background'} linkAction={() => { openUrl(link.url); }}>
                                <BoxLink icon={link.icon} text={link.description} />
                            </Box>
                        )
                    })}
                </Grid>
                <Grid container direction="row" justifyContent="space-between" alignItems="flex-start" style={{ paddingTop: '17px' }}>
                    {gstate.IsNorway.get() &&
                        <Box background>
                            <BoxTitle>
                                Kundeservice
                            </BoxTitle>
                            <BoxContent>
                                <div style={{ marginLeft: '20px' }}>
                                    Telefon: 915 02 445
                                </div>
                                    <div style={{ marginLeft: '20px' }}>
                                        E-post: kundeservice@chilimobil.no
                                </div>
                                    <div style={{ marginLeft: '20px' }}>
                                        Åpningstider: 08:00-16:00 - Man-fre
                                </div>
                            </BoxContent>
                        </Box>
                    }
                    {gstate.IsSweden.get() &&
                        <Box background linkAction={() => { openUrl('https://chilimobil.se/kontakta-oss/'); }}>
                        <BoxLink icon={'question'} text={'Kontakta oss'} />
                        </Box>
                    }
                    <Box background>
                        <BoxTitle>
                            {gstate.IsNorway.get() ? 'Om Chilimobil Min Side' : 'Om Chilimobil MittChili'}
                    </BoxTitle>
                        <BoxContent>
                            {gstate.IsNorway.get() ? 'Min Side er utviklet av Elkraps AB.' : 'MittChili är utvecklad av Elkraps AB.'}<br />
                            {gstate.IsNorway.get() ? 'Server versjon:' : 'Server version:'} {state.ServerVersion} {gstate.IsNorway.get() ? 'Klient versjon:' : 'Klient version'} {state.ClientVersion}
                        </BoxContent>
                    </Box>
                </Grid>
                {!wDim.large &&
                    <LargeButton style={{ marginTop: '27px' }} onClick={() => auth.signOutManually()}>{gstate.IsNorway.get() ? 'Logg ut' : 'Logga ut'}</LargeButton>
                }
            </TopContainer>
        </React.Fragment>
    );
}
